import React from 'react';
import styles from './Opponents.module.scss';

function Opponents({ opponents, onChange }) {
  return (
    <div className={styles.opponents}>
      {opponents.map((opponent, index) => (
        <div className={styles.opponent} key={opponent.name}>
          <input id={`opponent${index}`} type="radio" name="opponent" value={`opponent${index}`} defaultChecked={index === 0} onChange={onChange.bind(null, opponent)} />
          <label className={styles.opponentLabel} htmlFor={`opponent${index}`}>
            <span className={styles.opponentName}>{opponent.name}</span>
            <img className={styles.opponentImage} src={opponent.image} alt="" draggable="false" />
          </label>
        </div>
      ))}
    </div>
  );
}

export default Opponents;